import * as actionsList from './actions'

export const actions = actionsList

export { getRouteToPlayerHome, sortPlayers } from './constants'
export { getStatePlayer, default as reducer, registerReducer } from './reducer'
export { default as routes } from './routes'
export { default as PlayerForm } from './screens/PlayerFormScreen'
